<div>
  <div
    class="flex items-center gap-3 px-3 py-3 rounded-full hover:bg-foreground"
    (click)="toggleSection()"
    routerLinkActive="active"
    [routerLink]="menu.path"
    [ngClass]="{
      'justify-center': isCollapsed
    }"
  >
    <img [src]="'/icons/' + menu.icon + '.svg'" [ngClass]="isCollapsed ? 'h-6 w-6' : 'h-5 w-5'" />
    @if(!isCollapsed){
    <span class="text-sm font-medium">
      {{ menu.label }}
    </span>
    }
  </div>
  @if(sectionOpen){ @for (child of menu.children; track $index) { @if(!isCollapsed){ @if
  (!child.hidden) {
  <div class="ml-4">
    <a
      [routerLink]="`${menu.path}/${child.path}`"
      routerLinkActive="border-l-6 border-foreground"
      class="flex items-center gap-3 px-3 py-3 hover:border-l-6 hover:border-foreground"
      [ngClass]="{
        'justify-center': isCollapsed,
        'pl-3': !isCollapsed
      }"
    >
      @if (!isCollapsed) {
      <span class="text-sm font-medium">
        {{ child.label }}
      </span>
      }
    </a>
  </div>
  } } } }
</div>
